import client from '@/utils/httpClient';
import { useMutation, useQueryClient } from 'react-query';
import { VirtualConferenceDashboardKeys } from './virtualConferenceDashboard.keys';

function resetMeetingZoomData(meetingId: string) {
  return client.put(`/v1/meetings/${meetingId}/resetZoomData`);
}

export function useResetMeetingZoomData() {
  const queryClient = useQueryClient();

  return useMutation((meetingId: string) => resetMeetingZoomData(meetingId), {
    onSuccess: () => {
      queryClient.invalidateQueries(VirtualConferenceDashboardKeys.lists());
    },
  });
}
